import styled from 'styled-components'
import colors from '@settings/styleSettings'

export const Input = styled.input`
  width: 100%;
  min-height: 48px;
  border-radius: 12px;
  border: 1px solid ${colors.softGray};
  &:focus {
    border-color: ${colors.primary};
    outline: none;
  }
  ::placeholder {
    color: ${colors.strongGray};
  }
  font-family: inherit;
  color: ${colors.titleStrongBlack};
  font-size: inherit;
  box-sizing: border-box;
  padding: 0 16px;
  vertical-align: baseline;
  border: ${({ error }) => (error ? `1px solid ${colors.strongRed}` : `1px solid ${colors.softGray}`)};
  &:disabled {
    background-color: ${colors.grayBackground};
    color: ${colors.softGray};
  }

  @media(max-width: 550px) {
    font-size: 14px;
  }
`

export const ErrorMessage = styled.span`
  display: ${({ error }) => (error ? 'block' : 'none')};
  color: red; 
  overflow-wrap: break-word;
  position: absolute; // Adicionando posicionamento absoluto
  top: 100%; // Posicionando a mensagem de erro logo abaixo do input
  left: 0;
  font-size: 12px;
`

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative; // Adicionando posicionamento relativo para o contêiner
  width: 100%;
  max-width: 100%; // Limita a largura do contêiner à largura do campo de entrada
`
